import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import "./BusData.css";
import DeleteModal from "../../components/modals/DeleteModal";
import { Ripple } from "primereact/ripple";
import AddBusDataModal from "../../components/modals/AddBusDataModal";
import { Calendar } from "primereact/calendar";
import { useDispatch, useSelector } from "react-redux";
import {
  exportBusData,
  getAllBusesData,
  getBusDataUpdatedTime,
  uploadBusDataFile,
} from "../../services/bus.data.service";
import { getBusesWOL } from "../../services/buses.services";
import { CommonDropdown } from "../../components/common-input";
import moment from "moment";
import { Paginator } from "primereact/paginator";
import { getAgenciesWOL } from "../../services/agency.service";
import { agenciesSuccess } from "../../redux/agencies.slice";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import {
  areDatesWithinOneYear,
  capitalizeFirstLetter,
  handleDownloadFileTemplate,
  handleExport,
  limitDecimalToFourDigits,
} from "../../helpers/utils";
import { BUS_TECHNOLOGY } from "../../constants/constant.data";
import CommonBackdrop from "../../components/loader";

const BusDataPage = (props) => {
  const [sortMeta, setSortMeta] = useState({ sortField: "", sortOrder: "" });
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const hiddenFileInput = React.useRef(null);
  const { errorToast, successToast, toastRef } = useToast();
  const dispatch = useDispatch();
  const { allAgencies } = useSelector((state) => state.agencies);
  const { currentUser } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const [busData, setBusData] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [allBuses, setAllBuses] = useState([]);
  const [tableFilter, setTableFilter] = useState("");
  const [page, setPage] = useState(1);
  const [first, setFirst] = useState(0);
  const [dateFilter, setDateFilter] = useState(false);
  const [lastUpdated, setLastUpdatedTime] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "country.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "representative.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    company: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  let position;

  if (width > 950) {
    position = "255px";
  } else {
    position = "225px";
  }

  const template2 = {
    layout: "CurrentPageReport PrevPageLink PageLinks NextPageLink",
    CurrentPageReport: (options) => {
      return (
        <div className="mobileHideShowing">
          <span
            style={{
              color: "var(--text-color)",
              userSelect: "none",
              width: "160px",
              textAlign: "center",
            }}
          >
            Showing {options.first} - {options.last} of {options.totalRecords}
          </span>
        </div>
      );
    },
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">{"<"}</span>
          <Ripple />
        </button>
      );
    },
    PageLinks: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">{">"}</span>
          <Ripple />
        </button>
      );
    },
  };

  const handleGetBusesWOL = () => {
    getBusesWOL()
      .then((res) => {
        setAllBuses(res.data?.data);
      })
      .catch((err) => {
        errorToast(err);
      });
  };

  const handleGetBusData = async (currentPage, sorting) => {
    let filters = sorting
      ? {
          sortField: sorting.sortField,
          sortOrder: sorting.sortOrder,
        }
      : {
          sortField: sortMeta.sortField,
          sortOrder: sortMeta.sortOrder,
        };
    setLoading(true);
    getAllBusesData({
      page: currentPage || page,
      limit: 10,
      filters: {
        ...filters,
        ...tableFilter,
        startDate: dateFilter?.fromDate,
        endDate: dateFilter?.toDate,
      },
    })
      .then((res) => {
        setBusData(res.data?.busesData);
        setTotalCount(res?.data?.totalCount);
        setLoading(false);
      })
      .catch((error) => {
        errorToast(error);
        setLoading(false);
      });
  };

  const getAllAgencies = () => {
    getAgenciesWOL()
      .then((res) => {
        dispatch(agenciesSuccess(res?.data?.data));
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  useEffect(() => {
    handleGetBusesWOL();
    handleGetBusData();
    getAllAgencies();
  }, []);

  const getPastDate = (key) => {
    setDateFilter({
      fromDate: moment().subtract(key, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      key,
    });
  };

  const handleApply = () => {
    console.log("dateFilter = ", dateFilter);
    let isFromDateGreater = !moment(dateFilter["toDate"]).isAfter(
      moment(dateFilter["fromDate"])
    );
    if (isFromDateGreater) {
      errorToast(false, "Date error", "From Date must be less than To Date");
      return;
    }

    if (
      areDatesWithinOneYear(
        dateFilter["fromDate"] || moment().format("YYYY-MM-DD"),
        dateFilter["toDate"] || moment().format("YYYY-MM-DD")
      )
    ) {
      errorToast(false, "Date error", "From and To date must be within 1 year");
      return;
    }

    setPage(1);
    handleGetBusData(1);
  };

  const exportData = async () => {
    const result = await exportBusData();
    handleExport(result, "bus_data.csv");
  };

  const onPageChange = (event) => {
    setPage(event.page + 1);
    setFirst(event.first);
    handleGetBusData(event.page + 1);
  };

  const renderHeader = () => {
    return (
      <div className="headerButtons">
        <div className="startButtons">
          {currentUser?.role === "admin" && (
            <div className="selectBoxCharger">
              <CommonDropdown
                name="agencyId"
                optionArray={allAgencies}
                optionKey="_id"
                optionLabel="name"
                placeholder="Select Agency"
                label="Agency"
                style={{ height: "40px" }}
                isSelectAll
                value={tableFilter?.agencyId}
                onChange={(e) =>
                  setTableFilter({
                    ...tableFilter,
                    agencyId: e.target.value,
                  })
                }
              />
            </div>
          )}
          <div className="selectBoxCharger">
            <CommonDropdown
              name="busId"
              optionArray={
                currentUser?.role === "admin"
                  ? tableFilter &&
                    tableFilter["agencyId"] &&
                    allBuses.filter(
                      (b) => b.agencyId === tableFilter["agencyId"]
                    )
                  : allBuses.filter((b) =>
                      b.agencyId === currentUser?.parentId
                        ? currentUser?.parentId
                        : currentUser?._id
                    )
              }
              optionKey="_id"
              optionLabel="busNumberPlate"
              placeholder="Select Bus"
              label="Bus"
              value={tableFilter?.busId}
              style={{ height: "40px" }}
              onChange={(e) =>
                setTableFilter({
                  ...tableFilter,
                  busId: e.target.value,
                })
              }
              isSelectAll
            />
          </div>
          <div className="selectBox1">
            <Calendar
              inputId="from_date"
              placeholder={moment().format("MM/DD/YYYY")}
              dateFormat={"mm/dd/yy"}
              value={
                dateFilter?.fromDate
                  ? moment(dateFilter?.fromDate).toDate()
                  : new Date()
              }
              maxDate={new Date()}
              onChange={(e) =>
                setDateFilter({
                  ...dateFilter,
                  fromDate: moment(e.value).format("YYYY-MM-DD"),
                  key: "",
                })
              }
              showIcon
              readOnlyInput
            />
          </div>
          <div className="hyphenBox">-</div>
          <div className="selectBox1">
            <Calendar
              inputId="to_date"
              placeholder={moment().format("MM/DD/YYYY")}
              dateFormat={"mm/dd/yy"}
              value={
                dateFilter?.toDate
                  ? moment(dateFilter?.toDate).toDate()
                  : new Date()
              }
              maxDate={new Date()}
              onChange={(e) =>
                setDateFilter({
                  ...dateFilter,
                  toDate: moment(e.value).format("YYYY-MM-DD"),
                  key: "",
                })
              }
              showIcon
              readOnlyInput
            />
          </div>

          <select
            name=""
            id="selectBus"
            className="selectBus"
            placeholder="Buses"
            style={{ height: "40px", marginLeft: "5px" }}
            onChange={(e) => {
              getPastDate(e.target.value);
            }}
            value={dateFilter?.key}
          >
            <option value="" disabled selected hidden>
              Select date
            </option>
            <option value="7">Last 1 week</option>
            <option value="14">Last 2 weeks</option>
            <option value="30">Last Month</option>
            <option value="365">Last Year</option>
          </select>

          <Button
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              border: "0",
              width: "100px",
              textAlign: "center",
              fontStyle: "normal",
              fontWeight: "normal",
              marginLeft: "5px",
            }}
            label="Apply"
            onClick={() => {
              handleApply();
            }}
            placeholder="Apply"
          />
        </div>
        <div className="endButtons">
          <Button
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              border: "0",
              width: "120px",
            }}
            onClick={exportData}
            placeholder="Export Data "
            label="Export Data"
          />
        </div>
      </div>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-outlined p-button-icon-only mr-2"
          width="2rem"
        />
        <Button
          icon="pi pi-trash"
          className="p-button-danger p-button-outlined p-button-icon-only"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };

  const confirmDeleteProduct = () => {
    setDeleteProductDialog(true);
  };

  const header = renderHeader();

  const getUpdatedTime = async () => {
    getBusDataUpdatedTime()
      .then((res) => {
        setLastUpdatedTime(res?.data?.data[0]?.updatedAt);
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleBusDataAdded = (onlyModalClose) => {
    if (onlyModalClose) {
      setToggleAddModal(false);
      return;
    }
    successToast("Bus Data added successfully");
    setToggleAddModal(false);
    setPage(1);
    handleGetBusData(1);
    getUpdatedTime();
  };

  const dateBodyTemplate = (rowData) => {
    return moment(rowData.date).format("DD/MM/YYYY");
  };

  useEffect(() => {
    getUpdatedTime();
  }, []);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleImportBusData = (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    hiddenFileInput.current.value = null;
    setShowBackdrop(true);
    uploadBusDataFile(formData)
      .then((res) => {
        successToast(res.data?.message, "Bus data imported");
        setPage(1);
        handleGetBusData(1);
        getUpdatedTime();
        setShowBackdrop(false);
      })
      .catch((err) => {
        setShowBackdrop(false);
        errorToast(err);
        getUpdatedTime();
      });
  };

  const dynamicRowData = (rowData, key) => {
    const currentTechnology = BUS_TECHNOLOGY?.find(
      (x) => x?.key === rowData["busId"]?.technology
    );
    const H2Unit = (
      <span>
        {limitDecimalToFourDigits(rowData[key])} kg H<sub>2</sub>/100 km
      </span>
    );
    return (
      <React.Fragment>
        {rowData[key] && rowData[key] !== "0"
          ? currentTechnology?.dashboardUnit === "(kg H2/100 km)"
            ? H2Unit
            : `${limitDecimalToFourDigits(rowData[key])} ${
                currentTechnology?.dashboardUnit || ""
              }`
          : "N/A"}{" "}
      </React.Fragment>
    );
  };

  const handleSort = async (e) => {
    setSortMeta({
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
    setPage(1);
    setFirst(0);
    handleGetBusData(1, {
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
  };

  const modelYearDate = (rowData) => {
    return rowData.busId.serviceStartedAt
      ? moment.utc(rowData.busId.serviceStartedAt).format("YYYY")
      : "N/A";
  };

  return (
    <>
      <CommonBackdrop showBackdrop={showBackdrop} />
      <Toast ref={toastRef} />
      {toggleAddModal && (
        <AddBusDataModal allBuses={allBuses} toggleModal={handleBusDataAdded} />
      )}

      <div className="initialBox">
        <div className="welcomeBox">
          <strong>Bus Data</strong>
          <span
            style={{
              fontSize: "12px",
              marginBottom: "10px",
              marginLeft: "5px",
              fontWeight: "bold",
            }}
          >
            {lastUpdated &&
              `(Last updated on: ${moment(lastUpdated).format(
                "MM/DD/YYYY  h:mm a"
              )})`}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          <Button
            icon="pi pi-download"
            label="Sample File"
            style={{ width: "140px", border: "0", whiteSpace: "nowrap" }}
            onClick={() => handleDownloadFileTemplate("busData", "bus-data")}
          />
          <Button
            icon="pi pi-upload"
            label="Import Bus Data"
            style={{ width: "170px", border: "0", whiteSpace: "nowrap" }}
            onClick={handleClick}
          />

          <input
            ref={hiddenFileInput}
            style={{ display: "none" }}
            multiple="false"
            onChange={handleImportBusData}
            type="file"
            name="fileUpload"
            id="fileUpload"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />

          <Button
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              border: "0",
              width: "172px",
              height: "41px",
            }}
            placeholder="Add Bus Data"
            label="Add Bus Data"
            onClick={() => {
              setToggleAddModal(true);
            }}
          />
        </div>
      </div>

      {!loading && (
        <DataTable
          value={busData}
          stripedRows
          responsiveLayout="scroll"
          selectionMode="single"
          dataKey="id"
          header={header}
          filters={filters}
          emptyMessage="No Record found."
          sortField={sortMeta.sortField}
          sortOrder={sortMeta.sortOrder}
          sortMode="single"
          onSort={handleSort}
        >
          {currentUser?.role === "admin" && (
            <Column
              field="agencyId.name"
              header="Agency"
              style={{ backgroundColor: "" }}
            />
          )}

          <Column
            field="busId.busNumberPlate"
            header="Bus"
            style={{ backgroundColor: "" }}
          />

          <Column
            field="busId.serviceStartedAt"
            header="Model Year"
            body={modelYearDate}
            style={{ backgroundColor: "" }}
          />
          <Column
            field="date"
            style={{ whiteSpace: "nowrap" }}
            body={dateBodyTemplate}
            header="Date"
            sortable
          />
          <Column
            field="efficiency"
            header="Consumption Rate (km)"
            body={(rowData) => dynamicRowData(rowData, "efficiency")}
            sortable
          />
          <Column
            field="carBrokeDown"
            header="Did the vehicle breakdown?"
            sortable
            body={(rowData) => {
              return rowData.carBrokeDown
                ? capitalizeFirstLetter(rowData.carBrokeDown?.toLowerCase())
                : capitalizeFirstLetter("no");
            }}
          />
          <Column
            field="energyCost"
            body={(rowData) =>
              rowData["energyCost"]
                ? limitDecimalToFourDigits(rowData["energyCost"])
                : "N/A"
            }
            header="Energy Cost (C$) "
            sortable
          />
          <Column
            field="energyUsed"
            header="Energy Used"
            body={(rowData) => dynamicRowData(rowData, "energyUsed")}
            sortable
          />
          <Column
            field="distanceTravelled"
            header="Distance Travelled (km)"
            body={(rowData) =>
              limitDecimalToFourDigits(rowData["distanceTravelled"])
            }
            sortable
          />
        </DataTable>
      )}
      <br />
      <Paginator
        first={first}
        template={template2}
        rows={10}
        totalRecords={totalCount}
        rowsPerPageOptions={[10, 20, 30]}
        onPageChange={onPageChange}
      />
      {loading && <Skeleton height="28rem" />}

      {deleteProductDialog && (
        <DeleteModal
          deleteProductDialog={deleteProductDialog}
          onHide={() => setDeleteProductDialog(false)}
        />
      )}
    </>
  );
};

export default BusDataPage;
